import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
  Redirect,
} from "react-router-dom";

import Support from "@/pages/Support";
import Settings from "@/pages/Settings";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import SignUp from "@/pages/SignUp";
import ChangePassword from "@/components/settings/ChangePassword";
import VerificationCode from "@/pages/VerificationCode";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import ProtectedRoute from "@/components/ProtectedRoute";
import MFASettings from "@/pages/MFASettings";

// Admin Components
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminProtectedRoute from "@/components/AdminProtectedRoute";
import AdminQuickSight from "@/pages/admin/AdminDashboard";

// Used by Amplify for redirect after password reset link (if used)
const ResetPasswordCallback = () => {
  const history = useHistory();

  useEffect(() => {
    history.push("/login");
  }, [history]);

  return null; // ← MUST return something even if null
};

const AppRoutesContent = () => {
  return (
    <Switch>
      {/* Public Routes */}
      <Route path="/login" component={Login} />
      <Route path="/signup" component={SignUp} />
      <Route path="/change-password" component={ChangePassword} />
      <Route path="/verify-reset-code" component={VerificationCode} />
      <Route path="/reset-password-callback" component={ResetPasswordCallback} />
      <Route exact path="/" component={Login} />

      {/* Admin Routes */}
      <Route path="/admin/login" component={AdminLogin} />
      <Route path="/admin/forgot-password" component={AdminForgotPassword} />
      <Route path="/admin/change-password" component={ChangePassword} />
      <Route exact path="/admin" render={() => <Redirect to="/admin/login" />} />
      <AdminProtectedRoute path="/admin/dashboard" component={AdminDashboard} />
      <AdminProtectedRoute path="/admin/users" component={AdminUsers} />
      <AdminProtectedRoute path="/admin/quicksight" component={AdminQuickSight} />

      {/* Protected User Routes */}
      <ProtectedRoute path="/home" component={Home} />
      <ProtectedRoute path="/support" component={Support} />
      <ProtectedRoute path="/settings" component={Settings} />
      <ProtectedRoute path="/mfa-settings" component={MFASettings} />
    </Switch>
  );
};

const AppRoutes = () => (
  <Router>
    <AppRoutesContent />
  </Router>
);

export default AppRoutes;
